import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./app/pages/Homepage";
import Odalarimiz from "./app/pages/Odalarimiz";
import "./styles/font.css";
import "./styles/index.css";
import "./styles/tailwind.css";
import Menu from "./app/pages/Menu";
import "./i18n";
import { Helmet } from "react-helmet";

function App() {
  return (
    <div>
      <Helmet>
        <meta name="google" content="notranslate" />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/odalarimiz" element={<Odalarimiz />} />
          <Route path="/menu" element={<Menu />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
